export const environment = {
    production: false,
    timeout: 27,
    timeoutWarning: 3,
    contactEmail: 'OptumCAAttestations@optum.com',
    copyright: `© ${ new Date().getFullYear() } Optum, Inc. All rights reserved`
  };